// Query key constants to prevent duplication and typos
export const QUERY_KEYS = {
  getSessions: ["getSessions"] as const,
  getSession: (sessionId: string | null) => ["getSession", sessionId] as const,
  getChatTitle: "getChatTitle",
  getSources: (query: string | null) => ["getSources", query] as const,
} as const;
